import React from 'react';
import Icon from "../../../common/components/Icon";
import ProfileAdvertisementsItem from "../items/profile_advertisements_item";
import NoUserAd from "../items/no_user_ad";
import Loading from "../../../common/components/Loading";
import { AdFilterTabButtons } from "../ad/AdFilterTabButtons";
import { AdControlContent } from "../ad/AdControlContent";
import { t } from 'i18next';

export function AdvertisementsUI(
    handleBackClick,
    filter,
    setFilter,
    counts,
    searchText,
    handleSearchChange,
    categories,
    sort,
    handleSortChange,
    loading,
    filteredAdsData,
    getNoUserAdText,
    page,
    totalPages,
    setPage
) {
    return (
        <div className="w-full">
            {/* Mobile header */}
            <div className="flex items-center gap-3 px-1 pb-3 md:hidden">
                <Icon src="backicon" onClick={handleBackClick} className="w-5 h-5 cursor-pointer flex-shrink-0" />
                <span className="text-base font-semibold text-gray-800">{t('announcements')}</span>
            </div>

            {/* Filter tabs */}
            {AdFilterTabButtons(filter, setFilter, counts)}

            {/* Search + Sort */}
            {AdControlContent(searchText, handleSearchChange, categories, sort, handleSortChange)}

            {/* List */}
            <div className="flex flex-col gap-3">
                {loading ? (
                    <div className="py-10 flex justify-center"><Loading /></div>
                ) : filteredAdsData.length > 0 ? (
                    filteredAdsData.map(ad => (
                        <ProfileAdvertisementsItem key={ad.id} item={ad} />
                    ))
                ) : (
                    <NoUserAd {...getNoUserAdText()} />
                )}
            </div>

            {/* Pagination */}
            {!loading && totalPages > 1 && (
                <div className="flex items-center justify-center gap-1 mt-6">
                    <button
                        onClick={() => setPage(p => p - 1)}
                        disabled={page === 1}
                        className="w-9 h-9 flex items-center justify-center rounded-xl border border-gray-200 text-gray-500 hover:bg-gray-50 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
                    >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                            <path d="M15 19l-7-7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>

                    {Array.from({ length: totalPages }, (_, i) => i + 1)
                        .filter(p => p === 1 || p === totalPages || Math.abs(p - page) <= 1)
                        .reduce((acc, p, idx, arr) => {
                            if (idx > 0 && p - arr[idx - 1] > 1) acc.push('...');
                            acc.push(p);
                            return acc;
                        }, [])
                        .map((p, idx) =>
                            p === '...' ? (
                                <span key={`dot-${idx}`} className="w-9 h-9 flex items-center justify-center text-gray-400 text-sm">…</span>
                            ) : (
                                <button
                                    key={p}
                                    onClick={() => setPage(p)}
                                    className={`w-9 h-9 flex items-center justify-center rounded-xl text-sm font-medium transition-colors
                                        ${page === p
                                            ? 'bg-[#147F26] text-white'
                                            : 'border border-gray-200 text-gray-600 hover:bg-gray-50'
                                        }`}
                                >
                                    {p}
                                </button>
                            )
                        )
                    }

                    <button
                        onClick={() => setPage(p => p + 1)}
                        disabled={page === totalPages}
                        className="w-9 h-9 flex items-center justify-center rounded-xl border border-gray-200 text-gray-500 hover:bg-gray-50 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
                    >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                            <path d="M9 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>
                </div>
            )}
        </div>
    );
}
